import React from 'react';
import { Home, Calendar, Image, ListTodo, MoreHorizontal } from 'lucide-react';

interface BottomTabBarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const BottomTabBar: React.FC<BottomTabBarProps> = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'home', icon: Home, label: '홈' },
    { id: 'calendar', icon: Calendar, label: '달력' },
    { id: 'timeline', icon: Image, label: '타임라인' },
    { id: 'bucket', icon: ListTodo, label: '버킷리스트' },
    { id: 'more', icon: MoreHorizontal, label: '더보기' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-secondary pb-safe shadow-[0_-2px_10px_rgba(0,0,0,0.05)] z-50">
      <div className="flex justify-around items-center h-16 max-w-lg mx-auto">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`nav-item ${isActive ? 'active text-primary' : 'inactive text-gray-400'}`}
            >
              <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
              <span className="text-[10px]">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabBar;
